import { createTheme } from "@mui/material";
import { primarycolor } from "./colors";

const theme = createTheme({
    palette: {
        primary: {
            main: primarycolor
        },
        secondary: {
            main: "#FFFF"
        }
    },
    typography: {
        // "fontFamily": `"Roboto", "Helvetica", "Arial", sans-serif`,
        // "fontSize": 12,
        // "fontWeightLight": 300,
        // "fontWeightRegular": 400,
        // "fontWeightMedium": 500
    },
    tab: {
        textTransform: 'none',
    }
})

export default theme